import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";

export default function SearchBar({ value, onChange }) {
    return (
        <div className="library-search">
            <FontAwesomeIcon icon={faMagnifyingGlass} className="library-search-icon" />
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Search by product name..."
                className="library-search-input"
            />
        </div>
    );
}
